import { type ClassValue, clsx } from 'clsx';

/**
 * Combines class names conditionally
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

/**
 * Check if current time is within business hours (9am-5pm ET)
 */
export function isBusinessHours(): boolean {
  const now = new Date();
  const etTime = new Date(
    now.toLocaleString('en-US', { timeZone: 'America/New_York' })
  );
  const hours = etTime.getHours();
  const day = etTime.getDay();

  // Monday = 1, Friday = 5
  const isWeekday = day >= 1 && day <= 5;
  const isDuringHours = hours >= 9 && hours < 17;

  return isWeekday && isDuringHours;
}

/**
 * Format date for display
 */
export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/**
 * Get minimum date for date inputs (today)
 */
export function getMinDate(): string {
  return new Date().toISOString().split('T')[0];
}
